import { Search } from "@mui/icons-material";
import { Box, InputAdornment, Stack, TextField } from "@mui/material";
import { ChangeEvent, useMemo } from "react";

import { useExpandingSidebarActions, useExpandingSidebarData } from "../hooks";

import { ExpandingSidebarListProps } from "./ExpandingSidebar";
import { SidebarList } from "./SidebarList";

export function ExpandingSidebarList({ sidebarItems, showSearch }: ExpandingSidebarListProps) {
  const { searchValue } = useExpandingSidebarData();
  const { setSearchValue } = useExpandingSidebarActions();

  const filteredSidebarItems = useMemo(() => {
    if (!showSearch || !searchValue) return sidebarItems;

    return sidebarItems.filter((item) => {
      const searchKeyword = searchValue.toLowerCase();
      return item.identifier.toLowerCase().includes(searchKeyword);
    });
  }, [showSearch, sidebarItems, searchValue]);

  return (
    <Stack spacing={2}>
      {showSearch && (
        <Box px={1.5}>
          <TextField
            value={searchValue}
            placeholder="Search"
            onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ fontSize: 20 }} />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
      )}
      <Box>
        <SidebarList sidebarItems={filteredSidebarItems} />
      </Box>
    </Stack>
  );
}
